<template>
  <div class="under-header p-10" id="isotope-section" :style="backgroundImageStyle">
    <div class="mobile-background">
      <h1 class="font-medium layoutHeader mb-0 blur">{{ page?.altTitle || page?.title || 'Untitled Page' }}</h1>
      <Splitter class="featuredIsotopeSplitter">
        <SplitterPanel class="isotopesPanel" :size="75" :size-small="100">
              <div class="pr-4 periodic_table_wrapper desktop-only">
                <svg id="periodic_table" data-name="periodic table" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="100%" viewBox="0 0 2240 1161" :style="{ opacity: isTableInitializing ? 0.5 : 1, transition: 'opacity 0.3s ease' }">
                  <defs>
                    <style>
                      .st3 {
                        fill: #96fdeb;
                      }

                      .st4 {
                        fill: #7f73e6;
                      }

                      .st5 {
                        fill: #f5ceff;
                      }

                      .st7 {
                        fill: #cbd1ff;
                      }

                      .st1 {
                        fill: #fff;
                      }

                      #periodic_table text,
                      #periodic_table tspan {
                        font-size: 50px !important;
                      }
                    </style>
                  </defs>
                  <g id="purple">
                    <g>
                      <g id="Li">
                        <rect class="st4" x="50" y="170" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(78 238.5)"><tspan x="0" y="0">Li</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Mg">
                        <rect class="st4" x="170" y="290" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(181.9 358.5)"><tspan x="0" y="0">Mg</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ca">
                        <rect class="st4" x="170" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(187.3 478.5)"><tspan x="0" y="0">Ca</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Cr">
                        <rect class="st4" x="650" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(671.2 478.5)"><tspan x="0" y="0">Cr</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Cl">
                        <rect class="st4" x="1970" y="290" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(1994.4 358.5)"><tspan x="0" y="0">Cl</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Cu">
                        <rect class="st4" x="1250" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(1266.3 478.5)"><tspan x="0" y="0">Cu</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Zr">
                        <rect class="st4" x="410" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(432.9 598.5)"><tspan x="0" y="0">Zr</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ga">
                        <rect class="st4" x="1490" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(1506.5 478.5)"><tspan x="0" y="0">Ga</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Nd">
                        <rect class="st4" x="650" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(665 958.5)"><tspan x="0" y="0">Nd</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Sm">
                        <rect class="st4" x="890" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(899.4 958.5)"><tspan x="0" y="0">Sm</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Dy">
                        <rect class="st4" x="1370" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(1387.5 958.5)"><tspan x="0" y="0">Dy</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="S">
                        <rect class="st4" x="1850" y="290" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(1882.7 358.5)"><tspan x="0" y="0">S</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Br">
                        <rect class="st4" x="1970" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(1991.6 478.5)"><tspan x="0" y="0">Br</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Kr">
                        <rect class="st4" x="2090" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(2111.5 478.5)"><tspan x="0" y="0">Kr</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="V">
                        <rect class="st4" x="530" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(562.5 478.5)"><tspan x="0" y="0">V</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Pt">
                        <rect class="st4" x="1130" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(1152.4 718.5)"><tspan x="0" y="0">Pt</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ru">
                        <rect class="st4" x="890" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(906.9 598.5)"><tspan x="0" y="0">Ru</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Fe">
                        <rect class="st4" x="890" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st1" transform="translate(910.9 478.5)"><tspan x="0" y="0">Fe</tspan></text>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="pink">
                    <g>
                      <g id="Ni">
                        <rect class="st5" x="1130" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1153.2 478.5)"><tspan x="0" y="0">Ni</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Yb">
                        <rect class="st5" x="1850" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1867.1 958.5)"><tspan x="0" y="0">Yb</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Gd">
                        <rect class="st5" x="1130" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1145.4 958.5)"><tspan x="0" y="0">Gd</tspan></text>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="green">
                    <g>
                      <g id="Ti">
                        <rect class="st3" x="410" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(436.5 478.5)"><tspan x="0" y="0">Ti</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Zn">
                        <rect class="st3" x="1370" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1388 478.5)"><tspan x="0" y="0">Zn</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ge">
                        <rect class="st3" x="1610" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1626.5 478.5)"><tspan x="0" y="0">Ge</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Se">
                        <rect class="st3" x="1850" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1868.3 478.5)"><tspan x="0" y="0">Se</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="W">
                        <rect class="st3" x="650" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(676.1 718.5)"><tspan x="0" y="0">W</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Te">
                        <rect class="st3" x="1850" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1869.4 598.5)"><tspan x="0" y="0">Te</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Xe">
                        <rect class="st3" x="2090" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(2107.4 598.5)"><tspan x="0" y="0">Xe</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Mo">
                        <rect class="st3" x="650" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(662.1 598.5)"><tspan x="0" y="0">Mo</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ir">
                        <rect class="st3" x="1010" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1041.2 718.5)"><tspan x="0" y="0">Ir</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Si">
                        <rect class="st3" x="1610" y="290" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1635.4 358.5)"><tspan x="0" y="0">Si</tspan></text>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="faded" class="st6">
                    <g>
                      <g id="F">
                        <rect class="st7" x="1970" y="170" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(2005.4 238.5)"><tspan x="0" y="0">F</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="He">
                        <rect class="st7" x="2090" y="50" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(2106.3 118.5)"><tspan x="0" y="0">He</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="B">
                        <rect class="st7" x="1490" y="170" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1522.2 238.5)"><tspan x="0" y="0">B</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="C">
                        <rect class="st7" x="1610" y="170" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1641.8 238.5)"><tspan x="0" y="0">C</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="N">
                        <rect class="st7" x="1730" y="170" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1760.6 238.5)"><tspan x="0" y="0">N</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="O">
                        <rect class="st7" x="1850" y="170" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1880.5 238.5)"><tspan x="0" y="0">O</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ne">
                        <rect class="st7" x="2090" y="170" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(2106.1 238.5)"><tspan x="0" y="0">Ne</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Co">
                        <rect class="st7" x="1010" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1026.6 478.5)"><tspan x="0" y="0">Co</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Rh">
                        <rect class="st7" x="1010" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1026.9 598.5)"><tspan x="0" y="0">Rh</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Au">
                        <rect class="st7" x="1250" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1266.7 718.5)"><tspan x="0" y="0">Au</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Cd">
                        <rect class="st7" x="1370" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1386.2 598.5)"><tspan x="0" y="0">Cd</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Al">
                        <rect class="st7" x="1490" y="290" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1514.8 358.5)"><tspan x="0" y="0">Al</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Sn">
                        <rect class="st7" x="1610" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1627.2 598.5)"><tspan x="0" y="0">Sn</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Pb">
                        <rect class="st7" x="1610" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1627.5 718.5)"><tspan x="0" y="0">Pb</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="As">
                        <rect class="st7" x="1730" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1748.8 478.5)"><tspan x="0" y="0">As</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Bi">
                        <rect class="st7" x="1730" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1754.8 718.5)"><tspan x="0" y="0">Bi</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Po">
                        <rect class="st7" x="1850" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1867.9 718.5)"><tspan x="0" y="0">Po</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="I">
                        <rect class="st7" x="1970" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(2011.7 598.5)"><tspan x="0" y="0">I</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="At">
                        <rect class="st7" x="1970" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1991.5 718.5)"><tspan x="0" y="0">At</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ar">
                        <rect class="st7" x="2090" y="290" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(2111.6 358.5)"><tspan x="0" y="0">Ar</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Rn">
                        <rect class="st7" x="2090" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(2106.9 718.5)"><tspan x="0" y="0">Rn</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="P">
                        <rect class="st7" x="1730" y="290" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1763.1 358.5)"><tspan x="0" y="0">P</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Pd">
                        <rect class="st7" x="1130" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1147.5 598.5)"><tspan x="0" y="0">Pd</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ag">
                        <rect class="st7" x="1250" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1266.8 598.5)"><tspan x="0" y="0">Ag</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="In">
                        <rect class="st7" x="1490" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1516.3 598.5)"><tspan x="0" y="0">In</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Sb">
                        <rect class="st7" x="1730" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1747.1 598.5)"><tspan x="0" y="0">Sb</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Hg">
                        <rect class="st7" x="1370" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1385.4 718.5)"><tspan x="0" y="0">Hg</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Tl">
                        <rect class="st7" x="1490" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1516.5 718.5)"><tspan x="0" y="0">Tl</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Fr">
                        <rect class="st7" x="50" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(74.8 838.5)"><tspan x="0" y="0">Fr</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ra">
                        <rect class="st7" x="170" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(187.9 838.5)"><tspan x="0" y="0">Ra</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ac">
                        <rect class="st7" x="290" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(308.3 838.5)"><tspan x="0" y="0">Ac</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Rf">
                        <rect class="st7" x="410" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(432.3 838.5)"><tspan x="0" y="0">Rf</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Db">
                        <rect class="st7" x="530" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(545.9 838.5)"><tspan x="0" y="0">Db</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Sg">
                        <rect class="st7" x="650" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(667.3 838.5)"><tspan x="0" y="0">Sg</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Th">
                        <rect class="st7" x="410" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(428.3 1078.5)"><tspan x="0" y="0">Th</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Bh">
                        <rect class="st7" x="770" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(786.7 838.5)"><tspan x="0" y="0">Bh</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Pr">
                        <rect class="st7" x="530" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(552.5 958.5)"><tspan x="0" y="0">Pr</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Pa">
                        <rect class="st7" x="530" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(548.7 1078.5)"><tspan x="0" y="0">Pa</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Hs">
                        <rect class="st7" x="890" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(907.4 838.5)"><tspan x="0" y="0">Hs</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="U">
                        <rect class="st7" x="650" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(681.9 1078.5)"><tspan x="0" y="0">U</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Mt">
                        <rect class="st7" x="1010" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1026.6 838.5)"><tspan x="0" y="0">Mt</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Pm">
                        <rect class="st7" x="770" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(779.8 958.5)"><tspan x="0" y="0">Pm</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Np">
                        <rect class="st7" x="770" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(785 1078.5)"><tspan x="0" y="0">Np</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ds">
                        <rect class="st7" x="1130" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1148.1 838.5)"><tspan x="0" y="0">Ds</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Pu">
                        <rect class="st7" x="890" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(907.7 1078.5)"><tspan x="0" y="0">Pu</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Rg">
                        <rect class="st7" x="1250" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1267 838.5)"><tspan x="0" y="0">Rg</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Am">
                        <rect class="st7" x="1010" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1018.9 1078.5)"><tspan x="0" y="0">Am</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Cn">
                        <rect class="st7" x="1370" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1386.3 838.5)"><tspan x="0" y="0">Cn</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Cm">
                        <rect class="st7" x="1130" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1139.8 1078.5)"><tspan x="0" y="0">Cm</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Nh">
                        <rect class="st7" x="1490" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1505.1 838.5)"><tspan x="0" y="0">Nh</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Tb">
                        <rect class="st7" x="1250" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1268.2 958.5)"><tspan x="0" y="0">Tb</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Bk">
                        <rect class="st7" x="1250" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1267.6 1078.5)"><tspan x="0" y="0">Bk</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Fl">
                        <rect class="st7" x="1610" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1638 838.5)"><tspan x="0" y="0">Fl</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Cf">
                        <rect class="st7" x="1370" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1391.7 1078.5)"><tspan x="0" y="0">Cf</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Mc">
                        <rect class="st7" x="1730" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1743.4 838.5)"><tspan x="0" y="0">Mc</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ho">
                        <rect class="st7" x="1490" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1505.6 958.5)"><tspan x="0" y="0">Ho</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Es">
                        <rect class="st7" x="1490" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1510.8 1078.5)"><tspan x="0" y="0">Es</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Lv">
                        <rect class="st7" x="1850" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1871.9 838.5)"><tspan x="0" y="0">Lv</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Fm">
                        <rect class="st7" x="1610" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1622 1078.5)"><tspan x="0" y="0">Fm</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ts">
                        <rect class="st7" x="1970" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1990.4 838.5)"><tspan x="0" y="0">Ts</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Tm">
                        <rect class="st7" x="1730" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1740.5 958.5)"><tspan x="0" y="0">Tm</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Md">
                        <rect class="st7" x="1730" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1741.7 1078.5)"><tspan x="0" y="0">Md</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Og">
                        <rect class="st7" x="2090" y="770" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(2105.1 838.5)"><tspan x="0" y="0">Og</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="No">
                        <rect class="st7" x="1850" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1865.4 1078.5)"><tspan x="0" y="0">No</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Lr">
                        <rect class="st7" x="1970" y="1010" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1994.8 1078.5)"><tspan x="0" y="0">Lr</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ce">
                        <rect class="st7" x="410" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(427.3 958.5)"><tspan x="0" y="0">Ce</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Eu">
                        <rect class="st7" x="1010" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1028.7 958.5)"><tspan x="0" y="0">Eu</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Er">
                        <rect class="st7" x="1610" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1633.6 958.5)"><tspan x="0" y="0">Er</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Lu">
                        <rect class="st7" x="1970" y="890" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(1989.9 958.5)"><tspan x="0" y="0">Lu</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Be">
                        <rect class="st7" x="170" y="170" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(187.7 238.5)"><tspan x="0" y="0">Be</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Mn">
                        <rect class="st7" x="770" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(781.8 478.5)"><tspan x="0" y="0">Mn</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Tc">
                        <rect class="st7" x="770" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(789.9 598.5)"><tspan x="0" y="0">Tc</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Os">
                        <rect class="st7" x="890" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(907.2 718.5)"><tspan x="0" y="0">Os</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="H">
                        <rect class="st7" x="50" y="50" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(80.8 118.5)"><tspan x="0" y="0">H</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Re">
                        <rect class="st7" x="770" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(787.9 718.5)"><tspan x="0" y="0">Re</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Na">
                        <rect class="st7" x="50" y="290" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(66.1 358.5)"><tspan x="0" y="0">Na</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="K">
                        <rect class="st7" x="50" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(82.1 478.5)"><tspan x="0" y="0">K</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Cs">
                        <rect class="st7" x="50" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(68.4 718.5)"><tspan x="0" y="0">Cs</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Sc">
                        <rect class="st7" x="290" y="410" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(308.8 478.5)"><tspan x="0" y="0">Sc</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Y">
                        <rect class="st7" x="290" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(322.7 598.5)"><tspan x="0" y="0">Y</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Rb">
                        <rect class="st7" x="50" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(66.8 598.5)"><tspan x="0" y="0">Rb</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Sr">
                        <rect class="st7" x="170" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(192.1 598.5)"><tspan x="0" y="0">Sr</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ba">
                        <rect class="st7" x="170" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(187.7 718.5)"><tspan x="0" y="0">Ba</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="La">
                        <rect class="st7" x="290" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(310.9 718.5)"><tspan x="0" y="0">La</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Nb">
                        <rect class="st7" x="530" y="530" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(545 598.5)">Nb</text>
                          </g>
                        </g>
                      </g>
                      <g id="Hf">
                        <rect class="st7" x="410" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(430.7 718.5)"><tspan x="0" y="0">Hf</tspan></text>
                          </g>
                        </g>
                      </g>
                      <g id="Ta">
                        <rect class="st7" x="530" y="650" width="100" height="100" rx="18.1" ry="18.1"/>
                        <g class="st2">
                          <g class="st2">
                            <text class="st0" transform="translate(549.4 718.5)"><tspan x="0" y="0">Ta</tspan></text>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="pr-4 isotope_single_wrapper mobile-only">
                <div class="isotope-mobile-grid">
                  <!-- Current product portfolio (with modals) -->
                  <a 
                    v-for="isotope in currentPortfolioIsotopes" 
                    :key="isotope.symbol"
                    :id="isotope.symbol" 
                    :data-id="isotope.id"
                    class="isotope_single clickable"
                    :style="{ backgroundColor: '#96FDEB', color: '#333', border: '2px solid rgba(#96FDEB, 0.3)'}"
                    @click="openModal(isotope)"
                  >
                    <span class="isotope-symbol">{{ isotope.symbol }}</span>
                  </a>
                  
                  <!-- R&D precursor isotopes -->
                  <div 
                    v-for="symbol in rdPrecursorIsotopes" 
                    :key="symbol"
                    :id="symbol" 
                    class="isotope_single"
                    :style="{ backgroundColor: '#F5CEFF', color: '#333', border: '2px solid rgba(#F5CEFF, 0.3)'}"
                  >
                    <span class="isotope-symbol">{{ symbol }}</span>
                  </div>
                  
                  <!-- Other tech isotopes -->
                  <div 
                    v-for="symbol in otherTechIsotopes" 
                    :key="symbol"
                    :id="symbol" 
                    class="isotope_single"
                    :style="{ backgroundColor: '#2E4AA4', color: '#fff', border: '2px solid rgba(#2E4AA4, 0.3)'}"
                  >
                    <span class="isotope-symbol">{{ symbol }}</span>
                  </div>
                  
                  <!-- Suitable for separation isotopes -->
                  <div 
                    v-for="symbol in suitableSeparationIsotopes" 
                    :key="symbol"
                    :id="symbol" 
                    class="isotope_single"
                    :style="{ backgroundColor: '#7F73E6', color: '#fff', border: '2px solid rgba(#7F73E6, 0.3)'}"
                  >
                    <span class="isotope-symbol">{{ symbol }}</span>
                  </div>
                </div>
              </div>
        </SplitterPanel>
        <SplitterPanel class="isotopesPanel blur" :size="25" :size-small="100">
            <div class="p-4">
              <h2 class="m-0 p-0">Key</h2>
              <div 
                v-for="category in filterCategories" 
                :key="category.id" 
                class="mt-2 flex align-items-top"
              > 
                <Checkbox 
                  :modelValue="category.active" 
                  @update:modelValue="(value) => handleFilterToggle(category.id, value)"
                  :binary="true"
                  :style="{ 
                    '--p-checkbox-background': category.color,
                    '--p-checkbox-border-color': category.color,
                    '--p-checkbox-border-radius': '5px',
                    '--p-checkbox-checked-background': category.color,
                    '--p-checkbox-checked-border-color': category.color
                  }"
                />
                <p class="mt-0 ml-2 isotope_filter cursor-pointer" @click="handleFilterToggle(category.id, !category.active)">{{ category.label }}</p>
              </div>
              <div v-if="page?.imageTabbedContent" class="gap-4 desktop-only">
                <button 
                  @click="scrollToContentSection" 
                  class="cta cta--isotopes cursor-pointer text-white px-4 py-2 rounded-lg flex items-center"
                  aria-label="Scroll to conversion and development capabilities section"
                  title="Learn about our conversion and development capabilities"
                >
                  Learn about our conversion and development capabilities
                </button>
              </div>
            </div>
        </SplitterPanel>
      </Splitter>
      <IsotopeModal :visible="showModal" :isotope="selectedIsotope" @close="closeModal" @enquire="handleEnquireClick" />
      <IsotopeEnquiryForm :visible="showEnquiryForm" :selectedIsotope="enquiryIsotope" @close="closeEnquiryForm" />
    </div>
  </div>
  <div v-if="page?.imageTabbedContent" id="isotope-content" class="under-header additional-isotope p-10" :style="backgroundImageStyle">
    <div class="mobile-background">
      <div class="layoutHeader blur flex justify-end items-center pt-4 pb-4 mb-6">
          <div class="desktop-only">
            <button 
                @click="scrollToIsotopeSection" 
                class="cta cta--isotopes cursor-pointer text-white px-4 py-2 rounded-lg flex items-center"
                aria-label="Scroll back to Isotopes section"
                title="Back to Isotopes"
            >
                <i class="pi pi-arrow-up mr-5"></i>
                Back to products
            </button>
          </div>
      </div>
      <div class="featuredSplitter">
        <div class="flex-1">              
          <div v-if="page?.imageTabbedContent && page.imageTabbedContent.length > 0" class="page-content flex w-full">
              <Tabs v-model:value="activeTab">
                  <TabList>
                      <Tab v-for="(tab, idx) in page.imageTabbedContent" :key="tab.title" :value="idx">{{ tab.title }}</Tab>
                  </TabList>
                  <TabPanels class="pr-8 mr-8">
                      <TabPanel class="gap-6" v-for="(tab, idx) in page.imageTabbedContent" :key="tab.title" :value="idx">
                          <div class="md:w-1/2 w-full bt-custom">
                              <div v-if="tab.content" class="page-content pt-2 p-5 blur">
                                <div v-html="processContent(tab.content)"></div>
                              </div>
                              <div v-else class="text-500 text-center pt-2 p-5 blur">
                                  <p>No content available</p>
                              </div>
                          </div>
                          <div class="md:w-1/2 w-full">
                              <div v-if="tab.wistiaEmbed && isDirectVideoUrl(tab.wistiaEmbed)" class="wistia-embed">
                                  <OfflineVideo :src="resolveVideoSrc(tab.wistiaEmbed)" />
                              </div>
                              <div v-else-if="tab.wistiaEmbed" class="wistia-embed">
                                  <iframe :src="getWistiaEmbedUrl(tab.wistiaEmbed)" allowfullscreen="false" frameborder="0"></iframe>
                              </div>
                              <div v-else-if="resolveImageForTab(idx)" class="wistia-embed">
                                  <img :src="resolveImageForTab(idx)" :alt="`${tab?.title || 'Content'} image`">
                              </div>
                              <div v-else class="text-500 text-center p-5"></div>
                          </div>
                      </TabPanel>
                  </TabPanels>
              </Tabs>
          </div>
          <div v-else class="text-500 text-center p-5"><p>No content</p></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import ApiService from '../services/ApiService.js';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Checkbox from 'primevue/checkbox';
import IsotopeModal from '../components/IsotopeModal.vue';
import IsotopeEnquiryForm from '../components/IsotopeEnquiryForm.vue';
import OfflineVideo from '../components/OfflineVideo.vue';
import { useSVGInteraction } from '../composables/useSVGInteraction.js';
import { useIsotopeFiltering } from '../composables/useIsotopeFiltering.js';
import { processContent } from '../utils/markdown.js';
import { sortBySlug } from '../composables/useNavigation.js';
import { useCommonStyles } from '../composables/useCommonStyles.js';
import { useStrapiUrl } from '../composables/useStrapiUrl.js';
import { useMediaHelpers } from '../composables/useMediaHelpers.js';

// Initialize modal functions from composable
const { showModal, selectedIsotope, setupSVGInteractions, openModal, closeModal } = useSVGInteraction(() => ({
  current_portfolio: currentPortfolioIsotopes.value,
  rd_precursor: rdPrecursorIsotopes.value,
  other_tech: otherTechIsotopes.value
}));
// Filtering functionality
const { filterCategories, toggleFilter, initializeFilters, applyFiltersToSVG, hasActiveFilters } = useIsotopeFiltering(() => ({
  current_portfolio: currentPortfolioIsotopes.value,
  rd_precursor: rdPrecursorIsotopes.value,
  other_tech: otherTechIsotopes.value
}));

const props = defineProps({
  page: Object,
  settings: Object
});
const { getStrapiUrl } = useStrapiUrl();
const { isDirectVideoUrl, resolveVideoSrc, resolveImageUrl, getWistiaEmbedUrl } = useMediaHelpers();
const isotopes = ref([]);
const loading = ref(true);
const error = ref(null);
const additionalContentWithMedia = ref([]);
const isLoadingComponentMedia = ref(false);
const isTableInitializing = ref(true);
const activeTab = ref(0);

// Enquiry form state
const showEnquiryForm = ref(false);
const enquiryIsotope = ref('');

// Mobile isotope data arrays organized by category
// Current portfolio isotopes come from the API (fetchAllIsotopes)
const currentPortfolioIsotopes = computed(() => {
  return isotopes.value.filter(isotope => isotope.active);
});

const rdPrecursorIsotopes = ref([
  'Ni', 'Yb', 'Gd'
]);

const otherTechIsotopes = ref([
  'Cl', 'Fe', 'Ca', 'Mg', 'Dy', 'Nd', 'Sm', 'Cu', 'Cr', 'Zr', 'Ga', 'Kr', 'S', 'Li', 'V', 'Ru', 'Pt', 'Br'
]);

const suitableSeparationIsotopes = ref([
  
]);

// Handle filter toggle while preserving SVG colors
const handleFilterToggle = (filterId, value) => {
  const filter = filterCategories.value.find(f => f.id === filterId);
  if (filter) {
    filter.active = value;
    // Apply filters without interfering with SVG color management
    applyFiltersToSVG();
  }
};

// Enquiry form methods
const handleEnquireClick = (isotopeData) => {
  enquiryIsotope.value = isotopeData.symbol || isotopeData.name || '';
  showEnquiryForm.value = true;
};

const closeEnquiryForm = () => {
  showEnquiryForm.value = false;
  enquiryIsotope.value = '';
};

// Smooth scroll functions
const scrollToContentSection = () => {
  const contentElement = document.getElementById('isotope-content');
  if (contentElement) {
    contentElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

const scrollToIsotopeSection = () => {
  const isotopeElement = document.getElementById('isotope-section');
  if (isotopeElement) {
    isotopeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

const { backgroundImageStyle } = useCommonStyles(props);

const fetchAllIsotopes = async () => {
  loading.value = true;
  try {
    const response = await ApiService.getIsotopes();
    let isotopesData = [];
    if (response && Array.isArray(response.isotopes)) {
      isotopesData = response.isotopes;
    } else if (response && Array.isArray(response.data)) {
      isotopesData = response.data;
    } else if (Array.isArray(response)) {
      isotopesData = response;
    }
    isotopes.value = isotopesData;    
    isotopes.value.sort(sortBySlug);
  } catch (err) {
    isotopes.value = [];
    error.value = 'Error fetching all isotopes.';
    console.error('Error fetching all isotopes:', err);
  } finally {
    loading.value = false;
  }
};

// Function to fetch component media as cannot be handled by the StrapiService populate=*
const fetchComponentMedia = async () => {
  if (!props.page.imageTabbedContent.length === 0) {
    return;
  }
  isLoadingComponentMedia.value = true;
  try {
    const response = await ApiService.getPageComponents(props.page.slug, 'imageTabbedContent');
    if (response && response.data) {
      additionalContentWithMedia.value = response.data;
    }
  } catch (error) {
    console.error('Error fetching component media:', error);
  } finally {
    isLoadingComponentMedia.value = false;
  }
};

// Prevent scrolling functions - applies globally but only when this component is mounted
const preventScroll = (e) => {
  if (window.innerWidth > 960 && window.innerHeight >= 960) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
};

const preventKeyScroll = (e) => {
  if (window.innerWidth > 960 && window.innerHeight >= 960) {
    const activeElement = document.activeElement;
    const isFormElement = activeElement && (
      activeElement.tagName === 'INPUT' || 
      activeElement.tagName === 'TEXTAREA' || 
      activeElement.contentEditable === 'true' ||
      activeElement.classList.contains('p-inputtext') ||
      activeElement.classList.contains('p-inputtextarea')
    );
    
    if (!isFormElement && [32, 33, 34, 35, 36, 37, 38, 39, 40].includes(e.keyCode)) {
      e.preventDefault();
    }
  }
};

const preventMiddleMouseScroll = (e) => {
  if (window.innerWidth > 960 && window.innerHeight >= 960) {
    // Middle mouse button is button 1
    if (e.button === 1) {
      e.preventDefault();
    }
  }
};

const disableScrolling = () => {
  if (window.innerWidth > 960 && window.innerHeight >= 900) {
    document.addEventListener('wheel', preventScroll, { passive: false });
    document.addEventListener('touchmove', preventScroll, { passive: false });
    document.addEventListener('keydown', preventKeyScroll);
    document.addEventListener('mousedown', preventMiddleMouseScroll);
  }
};

const enableScrolling = () => {
  if (window.innerWidth > 960 && window.innerHeight >= 900) {
    document.removeEventListener('wheel', preventScroll);
    document.removeEventListener('touchmove', preventScroll);
    document.removeEventListener('keydown', preventKeyScroll);
    document.removeEventListener('mousedown', preventMiddleMouseScroll);
  }
};

const resolveImageForTab = (index) => {
  const apiImage = resolveImageUrl(additionalContentWithMedia.value?.[index]?.image);
  if (apiImage) {
    return apiImage;
  }

  return resolveImageUrl(props.page?.imageTabbedContent?.[index]?.image);
};


onMounted(async () => {
  await fetchAllIsotopes();
  initializeFilters();
  setupSVGInteractions(isotopes.value, hasActiveFilters);
  setTimeout(() => {
    isTableInitializing.value = false;
  }, 400);
  disableScrolling();
  fetchComponentMedia();
});

onUnmounted(() => {
  enableScrolling();
});
</script>
